import { render } from "./AddBonLivraison.vue?vue&type=template&id=ce21025c&scoped=true&ts=true"
import script from "./AddBonLivraison.vue?vue&type=script&lang=ts"
export * from "./AddBonLivraison.vue?vue&type=script&lang=ts"

import "./AddBonLivraison.vue?vue&type=style&index=0&id=ce21025c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce21025c"]])

export default __exports__